<template>
  <ul class="changelog-list">
    <li
      v-for="(item, index) in items"
      :key="item.id ?? index"
      class="changelog-list__item"
      :class="{ 'changelog-list__item--last': index === items.length - 1 }"
    >
      <div class="changelog-list__marker">
        <span class="changelog-list__dot"></span>
        <span
          v-if="index !== items.length - 1"
          class="changelog-list__line"
        ></span>
      </div>

      <div class="changelog-list__content">
        <span class="changelog-list__date">{{ formatDate(item.date) }}</span>
        <component
          :is="item.id ? 'a' : 'span'"
          class="changelog-list__title"
          :class="{ 'changelog-list__title--link': item.id }"
          @click="item.id && goToDetail(item.id)"
        >
          {{ item.title }}
        </component>
        <p class="changelog-list__description">{{ item.message }}</p>
      </div>
    </li>
  </ul>
</template>

<script setup>
import { inject } from 'vue'
import { useRouter } from 'vue-router'

defineProps({
  items: {
    type: Array,
    default: () => []
  }
})

const formatter = inject('formatter')
const router = useRouter()

const formatDate = date => (date ? formatter.date(date, 'fullDate') : '')

const goToDetail = id => router.push({ name: 'changelog-detail', params: { id } })
</script>

<style lang="scss" scoped>
.changelog-list {
  list-style: none;
  margin: 0;
  padding: 0;

  &__item {
    display: flex;
    gap: 12px;

    &--last .changelog-list__content {
      padding-bottom: 0;
    }
  }

  &__marker {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 4px;
  }

  &__dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: #9b6afa;
    flex-shrink: 0;
  }

  &__line {
    flex: 1;
    width: 2px;
    background-color: #e6e0f7;
    margin-top: 4px;
  }

  &__content {
    display: flex;
    flex-direction: column;
    gap: 4px;
    padding-bottom: 26px;
  }

  &__date {
    font-size: 12px;
    color: #9b6afa;
    font-weight: 600;
    letter-spacing: 0.02em;
  }

  &__title {
    font-size: 15px;
    font-weight: 700;
    color: #333333;
    line-height: 1.3;

    &--link {
      text-decoration: none;
      cursor: pointer;
      transition: color 0.15s ease;

      &:hover {
        color: #9b6afa;
        text-decoration: underline;
      }
    }
  }

  &__description {
    font-size: 14px;
    line-height: 1.5;
    color: #5c5c5c;
    margin: 0;
  }
}
</style>
